import React from "react"
import MyCard from "@common-utils/MyCard"
import MyTooltip from "@common-utils/MyTooltip"
import { Form, Formik } from "formik"
import MyInputField from "@common-utils/fields/MyInputField"
import MySelectGetAllDataFromServer from "@common-utils/fields/MySelectGetAllDataFromServer"
import { IBonsLivraisonManquantsOfGivenMonthRequestModel } from "./core/_models"
import { useBonsLivraisonManquantsOfGivenMonthListingContext } from "./BonsLivraisonManquantsOfGivenMonthListing"
import { useAuth } from "../../../../AppContext"
import { CONST_API_UTILS_GET_ACTIVE_PERSONNELS_ENDPOINT, CONST_API_UTILS_GET_CLIENTS_ENDPOINT, CONST_API_UTILS_GET_ENTITES_ENDPOINT } from "../../../../endpoints"
import MySelectField from "@common-utils/fields/MySelectField"
import { CONST_CLIENT_PROPAL_TYPE_ASSISTANCE_TECHNIQUE, CONST_CLIENT_PROPAL_TYPE_FORFAIT } from "@common-constants/*"

// Filters
const BonsLivraisonManquantsOfGivenMonthListingFilters = () => {
     const context = useBonsLivraisonManquantsOfGivenMonthListingContext()
     const { currentUser } = useAuth()

     const initialValues: IBonsLivraisonManquantsOfGivenMonthRequestModel = {
          ...context.filters,
     }

     function handleSubmit(values: IBonsLivraisonManquantsOfGivenMonthRequestModel) {
          context.setFilters(prev => ({
               ...prev,
               ...values,
          }))
          context.setAreFiltersVisible(false)
          context.setItemInPreview(null)
     }

     function handleReset() {
          context.filtersFormikRef.current.resetForm() // Reset local form
          context.simpleSearchBarFormikRef.current.resetForm() // Reset search bar form
          context.setItemInPreview(null)
          context.setAreFiltersVisible(false)

          // Reset payload filters
          context.setFilters(prev => ({
               mois: prev.mois,
               page: 1,
               pageLength: 20,
          }))

          context.filtersFormikRef.current.setSubmitting(true)
     }

     function handleClickHideFilters() {
          // Hide filters
          context.setAreFiltersVisible(prev => !prev)
          // Show preview only if it was opened before showing filters
          context.setItemInPreview(prev => {
               if (prev) {
                    return { ...prev, isPreviewVisible: true }
               }
               return null
          })
     }

     return (
          <MyCard>
               <MyCard.Header
                    isCollapseIconShown={false}
                    rightSideContent={
                         <MyTooltip title={"Cacher les filters"}>
                              <button className={"btn btn-sm btn-outline btn-outline-secondary "} onClick={handleClickHideFilters}>
                                   <i className={"fas fa-eye-slash fs-4 text-dark"} />
                              </button>
                         </MyTooltip>
                    }
               >
                    Filtres
               </MyCard.Header>

               <MyCard.Body>
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} innerRef={context.filtersFormikRef}>
                         {helpers => {
                              return (
                                   <Form noValidate autoComplete="off">
                                        <div className="row mb-5">
                                             <label className="col-lg-4 col-form-label fw-bold fs-6">Mot clé</label>

                                             {/* Simple search */}
                                             <div className="col-lg-8">
                                                  <MyInputField
                                                       name={"keyword"}
                                                       value={helpers.values.keyword}
                                                       onChange={val => {
                                                            helpers.setFieldValue("keyword", val).then()
                                                            context.simpleSearchBarFormikRef.current.setFieldValue("keyword", val).then()
                                                       }}
                                                       isInvalid={!!helpers.errors.keyword}
                                                       placeholder={"Rechercher ..."}
                                                  />
                                                  {helpers.errors.keyword && <div className={"text-danger"}>{helpers.errors.keyword}</div>}
                                             </div>
                                        </div>

                                        <div className="separator separator-dotted mt-4 mb-8"></div>

                                        {/* Entités */}
                                        <div className="row mb-4">
                                             <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Entités de facturation</label>

                                             <div className="col-lg-8">
                                                  <MySelectGetAllDataFromServer
                                                       name={"entitesFacturation"}
                                                       url={CONST_API_UTILS_GET_ENTITES_ENDPOINT}
                                                       value={helpers.values.entitesFacturation}
                                                       onChange={val => helpers.setFieldValue("entitesFacturation", val)}
                                                       isInvalid={!!helpers.errors.entitesFacturation}
                                                       isMulti
                                                  />
                                                  {helpers.errors.entitesFacturation && <div className={"text-danger"}>{helpers.errors.entitesFacturation}</div>}
                                             </div>
                                        </div>

                                        {/* Clients */}
                                        <div className="row mb-4">
                                             <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Clients</label>

                                             <div className="col-lg-8">
                                                  <MySelectGetAllDataFromServer
                                                       name={"clients"}
                                                       url={CONST_API_UTILS_GET_CLIENTS_ENDPOINT}
                                                       value={helpers.values.clients}
                                                       onChange={val => helpers.setFieldValue("clients", val)}
                                                       method={"GET"}
                                                       isInvalid={!!helpers.errors.clients}
                                                       isMulti
                                                  />
                                                  {helpers.errors.clients && <div className={"text-danger"}>{helpers.errors.clients}</div>}
                                             </div>
                                        </div>

                                        {/* Responsables */}
                                        <div className="row mb-4">
                                             <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Responsables</label>

                                             <div className="col-lg-8">
                                                  <MySelectGetAllDataFromServer
                                                       name={"responsables"}
                                                       url={CONST_API_UTILS_GET_ACTIVE_PERSONNELS_ENDPOINT}
                                                       value={helpers.values.responsables}
                                                       onChange={val => helpers.setFieldValue("responsables", val)}
                                                       method={"GET"}
                                                       isInvalid={!!helpers.errors.responsables}
                                                       isMulti
                                                  />
                                                  {helpers.errors.responsables && <div className={"text-danger"}>{helpers.errors.responsables}</div>}
                                             </div>
                                        </div>

                                        {/* AT ou Forfait */}
                                        <div className="row mb-4">
                                             <label className={`col-lg-4 col-form-label fw-bold fs-6`}>Forfait ou AT</label>

                                             <div className="col-lg-8">
                                                  <MySelectField
                                                       name={"forfaitOuAT"}
                                                       options={[
                                                            { value: CONST_CLIENT_PROPAL_TYPE_FORFAIT, label: "Forfait" },
                                                            { value: CONST_CLIENT_PROPAL_TYPE_ASSISTANCE_TECHNIQUE, label: "Assistance Technique" },
                                                       ]}
                                                       value={helpers.values.forfaitOuAT}
                                                       onChange={val => helpers.setFieldValue("forfaitOuAT", val)}
                                                       isInvalid={!!helpers.errors.forfaitOuAT}
                                                  />
                                                  {helpers.errors.forfaitOuAT && <div className={"text-danger"}>{helpers.errors.forfaitOuAT}</div>}
                                             </div>
                                        </div>

                                        <div className={"text-end"}>
                                             <button
                                                  className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                                  type={"button"}
                                                  disabled={helpers.isSubmitting}
                                                  onClick={() => handleReset()}
                                             >
                                                  <span className={"d-none d-lg-block"}>Réinitialiser</span> <i className={"fas fa-sync ms-lg-1"} />
                                             </button>
                                             <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                                  <span className={"d-none d-lg-block"}>Filtrer </span>
                                                  {!helpers.isSubmitting ? (
                                                       <i className={"fas fa-filter ms-md-1"} />
                                                  ) : (
                                                       <span className="spinner-border spinner-border-sm align-middle ms-lg-1" />
                                                  )}
                                             </button>
                                        </div>
                                   </Form>
                              )
                         }}
                    </Formik>
               </MyCard.Body>
          </MyCard>
     )
}

export default BonsLivraisonManquantsOfGivenMonthListingFilters
